<template>
    <div class="filter">
        <div class="btn-wrapper" :class="{'btn-wrapper--app': isApp}">
            <div v-for="(filter, i) in dropdowns" :key="'filter-' + i" class="btn" :class="['btn--' + filter, { 'btn--active': filters[filter].isActive }]" @click="toggleFilter(filter)">
                <span>{{ filters[filter].active }}</span>
                <img v-if="!filters[filter].isVisible" src="../../src/assets/svg/chevron-down.svg" alt="">
                <img v-else src="../../src/assets/svg/chevron-up.svg" alt="">
                <div v-show="filters[filter].isVisible" class="dropdown dropdown--type">
                    <div v-for="(type, n) in filters[filter].list" :key="'type-' + n" @click="filterDistrict(filter, type, n)">{{ type }}</div>
                </div>
            </div>
        </div>
        <div class="checkbox-wrapper">
            <div v-for="(checkbox, i) in checkboxes" :key="'checkbox-' + i" class="checkbox">
                <input :id="checkbox" v-model="filters[checkbox].value" type="checkbox" :value="checkbox">
                <label :for="checkbox">{{ filters[checkbox].name }}</label>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'LocationFilter',
        props: {
            'filters': Object,
            'geojson': Object,
            isApp: {
                type: Boolean,
                default: true,
            }
        },
        data () {
            return {
                dropdowns: ['district', 'type', 'kitchen'],
                checkboxes: ['budget'],
                districtBBox: [
                    [[16.355209350585938, 48.19953526207544], [16.384906768798828, 48.218496687697495]],
                    [[16.367440223693848, 48.16508359014628], [16.49846076965332, 48.23633632236363]],
                    [[16.375036239624023, 48.1753871811562], [16.431126594543457, 48.213177901228704]],
                    [[16.35937213897705, 48.18382885832668], [16.38113021850586, 48.20070804257699]],
                    [[16.341733932495117, 48.17922187800448], [16.36885643005371, 48.196932165522156]],
                    [[16.337313652038574, 48.188320980777746], [16.365938186645508, 48.20265308275373]],
                    [[16.33688449859619, 48.19587372580497], [16.361560821533203, 48.20854495959492]],
                    [[16.33842945098877, 48.20631413450164], [16.356496810913086, 48.21537983146641]],
                    [[16.34087562561035, 48.213807033816266], [16.37014389038086, 48.23630773818019]],
                    [[16.33194923400879, 48.11788960830668], [16.4370059967041, 48.188177925622824]],
                    [[16.395292282104492, 48.13796953555121], [16.513781547546387, 48.18729097474966]],
                    [[16.291823387145996, 48.15540777869529], [16.349716186523438, 48.18846403553334]],
                    [[16.18183135986328, 48.149452526083735], [16.32014751434326, 48.20705775366278]],
                    [[16.185178756713867, 48.18717652835758], [16.320533752441406, 48.26414116590925]],
                    [[16.31070613861084, 48.18382885832668], [16.339244842529297, 48.20722935655135]],
                    [[16.253628730773926, 48.202853303285195], [16.339244842529297, 48.22704562192814]],
                    [[16.249380111694336, 48.212148394866176], [16.341991424560547, 48.25831283152371]],
                    [[16.282382011413574, 48.21723853003891], [16.353750228881836, 48.25096932707115]],
                    [[16.285085678100586, 48.231934169971936], [16.37237548828125, 48.283192895483495]],
                    [[16.361217498779297, 48.2251015081371], [16.39812469482422, 48.26271271405642]],
                    [[16.356067657470703, 48.23633632236363], [16.47472858428955, 48.283192895483495]],
                    [[16.435546875, 48.13522010932232], [16.577467918395996, 48.283192895483495]],
                    [[16.20985507965088, 48.11943670062698], [16.3771390914917, 48.1626791210285]]
                ]
            };
        },
        methods: {
            changeBounds(n) {
                this.$parent.$refs.map.mapObject.fitBounds([[this.districtBBox[n][0][1], this.districtBBox[n][0][0]], [this.districtBBox[n][1][1], this.districtBBox[n][1][0]]], { padding: [30, 30] });
            },
            filterDistrict(filter, type, n) {
                this.filters[filter].active = type;
                this.filters[filter].isActive = n > 0;

                if (filter === 'district'){
                    this.geojson.options.activeDistrict = n;
                    if (n > 0){
                        this.changeBounds(n - 1);
                    }
                }
            },
            toggleFilter(thisFilter){
                if (this.filters[thisFilter].isVisible){
                    this.closeFilter();
                } else {
                    this.openFilter(thisFilter);
                }
            },
            openFilter(thisFilter){
                this.closeFilter();
                this.filters[thisFilter].isVisible = true;
            },
            closeFilter(){
                for(let i = 0; i < this.dropdowns.length; i++){
                    this.filters[this.dropdowns[i]].isVisible = false;
                }
            }
        }
    };
</script>

